import { render, staticRenderFns } from "./Routines.vue?vue&type=template&id=37e659dd"
import script from "./Routines.vue?vue&type=script&lang=js"
export * from "./Routines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports